import { render, staticRenderFns } from "./QuoteTag.vue?vue&type=template&id=3f620cd8&scoped=true&"
import script from "./QuoteTag.vue?vue&type=script&lang=js&"
export * from "./QuoteTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f620cd8",
  null
  
)

export default component.exports